import axios from "axios";

class shareService {
  constructor() {
    this.API_URL = process.env.REACT_APP_API_URL_V;
    this.apiClient = axios.create({
      baseURL: this.API_URL,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    this.apiClient.interceptors.request.use(
      (config) => {
        //   const token = JSON.parse(localStorage.getItem('loginInfonetApp'))?.token || '';
        //   console.log(token)
        const token = localStorage.getItem("accesstoken");
        config.headers["x-auth-token"] = token;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  async getshares(data) {
    const response = await this.apiClient.post("/share/list", data);
    return response.data.data;
  }
  async getSingleShare(id, data) {
    const response = await this.apiClient.post("/shareget/" + id, data);
    return response.data.data;
  }
  async getFilename(id, data) {
    const response = await this.apiClient.post(
      "/share/getfilename/" + id,
      data
    );
    return response.data;
  }

  async verifyLogin(id, data) {
    const response = await this.apiClient.post("/sharelogin/" + id, data);
    return response.data.data;
  }
  async addshare(share) {
    const response = await this.apiClient.post("/sharecreate", share);
    console.log(response.data.data);
    return response.data.data;
  }
  async addVideoshare(share) {
    const response = await this.apiClient.post("/videosharecreate", share);
    console.log(response.data.data);
    return response.data.data;
  }
  async addhtmlshare(share) {
    const response = await this.apiClient.post("/sharehtmlcreate", share);
    console.log(response.data.data);
    return response.data.data;
  }
  async updateshare(id, share) {
    const response = await this.apiClient.put(`/shareupdate/${id}`, share);
    return response.data;
  }

  async deleteshare(id) {
    const response = await this.apiClient.delete(`/sharedelete/${id}`);
    return response.data;
  }

  async redirect(id) {
    const response = await this.apiClient.get(`/share/navigate/${id}`);
    return response.data.data;
  }

  async sharedlist(data) {
    const response = await this.apiClient.post("/share/sharedlist", data);

    return response.data.data;
  }

  async sharedHtmlList(data) {
    const response = await this.apiClient.post("/share/sharedhtmlist", data);

    return response.data.data;
  }
  async userLogs(data) {
    const response = await this.apiClient.post("/userlogs", data);

    return response.data.data;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new shareService();
